'use client';

import { NotFoundContent } from '@/components/NotFoundContent';

/**
 * Root not-found.tsx — Fallback for routes without locale context.
 * Uses Arabic as default since it's the x-default locale.
 */
export default function NotFound() {
    return (
        <NotFoundContent
            title="يبدو أننا فقدنا الخريطة!"
            description="الصفحة التي تبحث عنها غير موجودة أو تم نقلها. لكن لا تقلق، إيكو بوي هنا لإرشادك للعودة."
            backHomeLabel="العودة للرئيسية"
            goBackLabel="الرجوع للسابق"
            homeHref="/ar"
            isRTL={true}
        />
    );
}
